module.exports = __webpack_public_path__ + "static/media/alchemist-staff-1.6c480096.glb";